<template>
  <div class="products-archive__section-wrapper">
    <div v-for="item in items" class="products-archive__section">
      <div class="uk-section-bottom-xsmall">
        <h2 class="uk-font-light">{{ item.subtitle !== '' ? item.subtitle + ' ' : '' }}<strong>{{ item.title }}</strong></h2>
        <p class="section__text--large" v-html="item.abstract"></p>
      </div>
        <div class="uk-grid" uk-grid>
          <div v-for="product in item.products" class="uk-width-1-2@s uk-width-1-3@tablet uk-width-1-3@m uk-width-1-4@l">
            <product-card :product="product"></product-card>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataGridResults from 'js/theme-mixins/DataGridResults';

export default {
  mixins: [DataGridResults],
  computed: {
    itemNumber() {
      return this.items.length
    }
  },
  watch: {
    items() {
      this.$nextTick(function () {
        document.querySelectorAll(".professional-card-image").forEach(img => {
          img.classList.add("lazyload");
        })
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/AllProductsDataGridResults.vue